"use client";

import { Typography } from "../ui/typography";
import { usePdpPrices } from "@/lib/react-query/queries/accommodation/use-pdp-prices";
import { usePdpStayDates } from "@/hooks/usePdpStayDates";
import { formatNumber } from "@/utils/format/formatNumber";

/**
 * Bookable origin count for the mobile prices tab.
 * Its own client island so StayOverview can stay a Server Component; it shares
 * the React Query cache entry with the price card, so no extra request.
 */
export function PdpPricesTabCount({
  accommodationId,
}: {
  accommodationId: string;
}) {
  const { checkIn, checkOut, capacity } = usePdpStayDates();
  const { data } = usePdpPrices({
    accommodationId,
    checkIn,
    checkOut,
    capacity,
  });

  const count = data?.supported.length ?? 0;
  if (count <= 0) return null;

  return (
    <Typography as="span" variant="captionRegular">
      ({formatNumber(count)})
    </Typography>
  );
}
